import React, { Fragment } from 'react';
import { node, shape } from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router';
import withApplicationConfig from 'containers/withApplicationConfig';
import { withCookies } from 'react-cookie';

class LanguageCookie extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  static getDerivedStateFromProps({ cookies, match: { params }, localisation }) {
    const { language } = params;
    if (!language) return null;
    if (!_.has(localisation, language)) return null;
    const defaultLanguage = cookies.get('defaultLanguage');
    if (language === defaultLanguage) return null;
    cookies.set('defaultLanguage', language, { path: '/' });
    return null;
  }

  render() {
    const { children } = this.props;
    return (
      <Fragment>
        {children}
      </Fragment>
    );
  }
}

LanguageCookie.propTypes = {
  localisation: shape({}),
  match: shape({}),
  children: node,
  cookies: shape({}),
};

LanguageCookie.defaultProps = {
  localisation: {},
  match: {},
  children: null,
  cookies: {},
};

export default withCookies(withRouter(withApplicationConfig(LanguageCookie, ['languages'])));
